export enum FacilityCacheKeys {
  LICENSE = 'time-card-license',
  LegacyOpenShifts = 'facility-legacy-openshifts',
  OpenShiftsV2 = 'facility-openshifts-v2',
  OpenShiftsEmployeesV2 = 'facility-openshifts-employees-v2',
  EmployeeSchedules = 'employee-schedules',
}

export enum ManageScheduleCacheKeys {
  AbsenceReasons = 'scheduler-absence-reasons',
  PlannedAbsence = 'scheduler-planned-absence',
  ScheduleCalendarAbsences = 'schedule-calendar-absences',

  ScheduleCalendar = 'scheduler-schedule-calendar',
  SchedulerStartDate = 'scheduler-start-date',
  DisplaySchedule = 'scheduler-display-schedule',
  AssignedEmployees = 'scheduler-assigned-employees',
  AvailableEmployees = 'scheduler-available-employees',
  NotifiedEmployees = 'scheduler-notified-employees',
  InterestedEmployees = 'scheduler-interested-employees',
  DailyView = 'scheduler-daily-view',
  DailyView1 = 'scheduler-daily-view-1',
  DisplayViewSummary = 'scheduler-display-view-summary',
  EmployeeScheduleTotalBudgets = 'scheduler-employee-schedules-total-budgets',
  EmployeeScheduleShiftBudgets = 'scheduler-employee-schedules-shift-budgets',
}

export enum EmployeeCacheKeys {
  EmployeeAbsenceRequests = 'employee-absence-requests',
  EmployeeAccruals = 'employee-accruals',
  EmployeeAccountProfile = 'employee-account-profile',
  EmployeeStatusType = 'employee-status-type',
  EMPLOYEES = 'time-card-employees',
  EmployeePermissions = 'employee-permissions',
  EmployeeLaborLevelLevels = 'employee-labor-level-levels',
  EMPLOYEE = 'time-card-employee',
  EmployeeHeader = 'timecard-employee-header',

  EMPLOYEE_PAY_RULES = 'time-card-employee-pay-rules',
  EMPLOYEE_BASE_SCHEDULE_GROUPS = 'time-card-employee-base-schedule-groups',
  EMPLOYEE_HOLIDAY_GROUPS = 'time-card-employee-holiday-groups',
  EMPLOYEE_ACCRUAL_GROUPS = 'time-card-employee-accrual-groups',
  EMPLOYEE_WORK_PATTERN_SHIFTS_AUDITS = 'time-card-employee-work-pattern-shifts-audits',
  EMPLOYEE_HISTORY_AUDITS = 'time-card-employee-history-audits',
  EMPLOYEE_EMPLOYMENT_AUDIT = 'time-card-employee-employment-audit',
  EMPLOYEE_PAY_TYPE_WITH_OPTION = 'time-card-employee-pay-type-with-option',

  EMPLOYEE_AUDITS = 'time-card-employee-audits',
  EMPLOYEE_HEALTH_AUDITS = 'time-card-employee-audit-health',
  EMPLOYEE_WORK_PATTERN_AUDITS = 'time-card-employee-work-pattern-audits',
  EMPLOYEE_LICENSE_AUDIT = 'time-card-employee-licenses-audits',
  EMPLOYEE_PAY_RATES_AUDITS = 'time-card-employee-pay-rates-audits',
  EMPLOYEE_MISC_AUDIT = 'time-card-employee-audit-misc',
  EMPLOYEE_CONTACT_INFO_AUDIT = 'time-card-employee-contact-info-audit',
  EMPLOYEE_AUTHORIZATION_AUDIT = 'time-card-employee-authorization-audit',
  EMPLOYEE_IN_SERVICE_AUDIT = 'time-card-employee-in-service-audit',
  EMPLOYEE_JOURNAL_AUDIT = 'time-card-employee-journal-audit',
  EMPLOYEE_PAY_RATES_SETTINGS = 'time-card-employee-pay-rates-settings',
  EMPLOYEE_PAY_RATES = 'time-card-employee-pay-rates',

  HOLIDAYS = 'time-card-holidays',
  LOGGED_IN_EMPLOYEE_USER = 'time-card-logged-in-employee-user',
  FACILITY_TIME_CLOCKS = 'time-card-facility-time-clocks',
  EMPLOYEE_STATUSES = 'time-card-employee-statuses',
  EMPLOYEE_HISTORY = 'time-card-employee-history',
  CONTACT_INFO = 'time-card-employee-contact-info',
  WORK_PATTERN = 'time-card-work-pattern',
  WORK_PATTERN_CONFIGURATION = 'time-card-work-pattern-configuration',
  SHIFT_HISTORY = 'time-card-shift-history',
  EMPLOYEE_MISC = 'time-card-employee-mis',
  EMPLOYEE_LICENSES = 'time-card-employee-licenses',
  EMPLOYEE_JOURNALS = 'employee-journals',
  EMPLOYEE_IN_SERVICE = 'time-card-employee-in-service',
  EMPLOYEE_IN_SERVICE_LIST = 'time-card-employee-in-service-list',
  EMPLOYEE_SALARIED_HOURS = 'time-card-employee-salaried-hours',
  EMPLOYEE_AUTHORIZATION_CONFIG = 'time-card-employee-authorization-config',
  EMPLOYEE_AUTHORIZATION = 'time-card-employee-authorization',
  EMPLOYEE_CLOCK_INFO_LABOR_LEVELS = 'employee-clock-info-labor-levels',
  EMPLOYEE_CLOCK_INFO_LIST = 'employee-clock-info-list',
  EMPLOYEE_CREATE = 'time-card-create-employee',
  EMPLOYEE_GET_ID = 'time-card-get-id',
  EMPLOYEE_CHECK_LABOR_LEVELS = 'time-card-employee-check-labor-levels',
  EMPLOYEE_PERIOD_GROUP = 'time-card-employee-period-group',
  EMPLOYEE_WORK_PATTERN_TYPES = 'time-card-employee-work-pattern-types',
  BUDGET_GROUP_LABOR_LEVELS = 'time-card-budget-group-labor-levels',
  DEPARTMENT_LABOR_LEVELS = 'time-card-department-labor-levels',
  EMPLOYEE_EFFECTIVE_DATE_CONFIG = 'time-card-employee-effective-date-config',
  EMPLOYEE_HISTORY_TYPES = 'time-card-employee-history-types',
  EMPLOYEE_HISTORY_MIN_EFFECTIVE_DATE = 'time-card-employee-history-min-effective-date',
  EMPLOYEE_UNDO_STACK = 'employee-undo-stack',
  EMPLOYEE_CUSTOM_TABS = 'time-card-employee-custom-tabs',
}

export enum HrCacheKeys {
  EmployeeStatus = 'employee-status-get',
  PositionCoverageEmployee = 'scheduler-position-coverage-employee',
  ACCRUALS_GET = 'sbv-pro-accruals-get',
  SCHEDULER_TAB_VISIBILITY = 'hr-employee-scheduler-tab-visibility',
}

export enum SchedulerMasterViewCacheKeys {
  MasterView = 'master-view',
  Employees = 'employees',
  Drafts = 'drafts',
  Overbudget = 'overbudget',
}

export enum OpeningTemplateCacheKeys {
  OpeningTemplate = 'scheduler-opening-template',
  AvailableEmployees = 'available-employees',
}

export enum SchedulerDepartmentCacheKeys {
  PayPeriods = 'scheduler-pay-periods',
  Departments = 'scheduler-departments',
  SchedulerPeriods = 'scheduler-schedule-periods',
}

export enum SchedulerPositionCacheKeys {
  Positions = 'scheduler-positions',
}

export enum ProLaborLevelDesignationCacheKeys {
  ProLaborLevelDesignations = 'pro-labor-level-designations',
}

export enum SchedulerUnitCacheKeys {
  Units = 'scheduler-units',
  UnitsByShiftTypeAndPosition = 'scheduler-units-by-shift-type-and-position',
}

export enum ShiftTypeCacheKeys {
  ShiftTypes = 'scheduler-shift-types',
}

export enum SchedulerEmployerCacheKeys {
  Employers = 'scheduler-employers',
  Employees = 'scheduler-employees',
  SchedulePattern = 'scheduler-employee-schedule-pattern',
  MasterView = 'scheduler-master-view',
}

export enum SchedulerMetaCacheKeys {
  ShiftTypes = 'scheduler-shift-types-meta',
  PeriodTypes = 'scheduler-period-types-meta',
}

export enum HrCacheKeys {}

export enum ComplianceCacheKeys {
  HppdCensus = 'hppd-census',
}

export enum ReportCacheKeys {
  AbsenseReport = 'absense-report',
  SavedReports = 'saved-reports',
  StaticReports = 'static-reports',
  ReportConfiguration = 'report-configuration',
}

export enum OpenShiftsCacheKeys {
  Config = 'open-shifts-config',
}

export enum LaborLevelCacheKeys {
  Facilities = 'labor-level-facilities',
}

export enum RolesCacheKeys {
  Roles = 'roles',
  Permissions = 'permissions',
  Users = 'users',
}

export enum AdminCacheKeys {
  AdminFacilityDashboard = 'admin-facility-dashboard',
  AdminFacilityConfig = 'admin-facility-config',
}

export enum AbsencesCacheKeys {
  AbsenceReasonsPlannedAbsences = 'absence-reasons-planned-absences',
  AbsenceReasonsScheduler = 'absence-reasons-scheduler',
}

export enum EntityListCacheKeys {
  Shifts = 'shifts',
  ShiftList = 'shift-list',
  EmployeeShiftType = 'EmployeeShiftType',
  HoursType = 'HoursType',
  StandardComment = 'StandardComment',
  CommentType = 'CommentType',
  HoursSummaryFormat = 'HoursSummaryFormat',
  SchedulerType = 'SchedulerType',
  OtherHoursPaymentStatusType = 'otherHoursPaymentStatusType',
  PBJStatusType = 'pbjStatusType',
  WorkPatternType = 'workPatternType',
  GenderTypes = 'genderTypes',
  RaceTypes = 'raceTypes',
  LicenseType = 'licenseType',
  InfluenzaType = 'influenzaType',
  DrugScreenType = 'drugScreenType',
  StateListType = 'stateListType',
  I9DocumentsA = 'i9-documents-a',
  I9DocumentsAFriendlyNames = 'i9-documents-a-friendly-names',
  I9DocumentsB = 'i9-documents-b',
  I9DocumentsBFriendlyNames = 'i9-documents-b-friendly-names',
  I9DocumentsC = 'i9-documents-c',
  I9DocumentsCFriendlyNames = 'i9-documents-c-friendly-names',
  PunchTypes = 'time-card-punch-types',
  PunchSources = 'time-card-punch-sources',
  STATE_LIST = 'state-list',
  AllLaborLevels = 'all-labour-levels',
  FacilityLaborLevelLevels = 'facility-labor-level-levels',
  ExceptionTypes = 'exception-types',
  EEOCTypes = 'eeoc-types',
  CHICKENPOX_VACCINATION_TYPES = 'time-card-chickenpox-vaccination-types',
  CHICKENPOX_HISTORY_TYPES = 'time-card-chickenpox-history-types',
  SCHEDULE_STATUS_TYPES = 'time-card-schedule-status-types',
  BREAK_GROUP_TYPES = 'time-card-break-group-types',
  EMPLOYEE_EFFECTIVE_DATE_DICTIONARY = 'employee-effective-date-dictionary',
  PUNCHING_ZONES = 'time-card-punch-zones',
  EMPLOYEES_LOOK_IN = 'employees-look-in',

  EXCEPTION_TYPES = 'time-card-exception-types',
  REASON_TYPES = 'time-card-reason-types',
  PAY_PERIODS = 'time-card-pay-periods',
  EMPLOYEE_STATUS_TYPE = 'time-card-employee-status-types',
  STATUS_TYPES_LIST = 'time-card-status-types-list',
  FIND_EMPLOYEE_LOOK_INS = 'time-card-find-employee-look-ins',
  EMPLOYEE_INFO_TEXT_FIELDS_LIST = 'time-card-employee-info-text-fields-list',
  HOURS_SUMMARY_FORMAT = 'time-card-hours-summary-format',
  EMPLOYEE_GROUPING_DISPLAY_ORDER_TEXT = 'time-card-employee-grouping-display-order-text',
  PAY_RULE_TYPES_LIST = 'time-card-pay-rule-types-list',
  EMPLOYEE_SHIFT_TYPES = 'time-card-employee-shift-types',
  EEOC_TYPES = 'time-card-eeoc-types',
  HEPATITIS_B_DUE_TYPES = 'time-card-hepatitis-b-due-types',
  HEPATITIS_B_RECEIVED_TYPES = 'time-card-hepatitis-b-received-types',
  RELATIONSHIP_TYPES = 'time-card-relationship-types',
  EMPLOYEE_LICENSE_TYPE = 'employee-license-type',
  IN_SERVICE_CATEGORY_DICTIONARY_LIST = 'in-service-category-list',
  IN_SERVICE_GROUP_DICTIONARY_LOST = 'in-service-dictionary-list',
  SCHEDULE_STATUS_TYPES_WITH_OPTIONS = 'in-service-dictionary-list_with_options',
  FACILITY_LABOR_LEVELS = 'facility-labor-levels',
  ACCRUAL_GROUPS_FACILITY = 'accrual-groups-facility',
  HOLIDAY_GROUPS_FACILITY = 'holiday-groups-facility',
  SCHEDULE_GROUPS_FACILITY = 'schedule-groups-facility',
  LABOR_LEVELS_CHECK_NO_EMPLOYEE = 'labor-levels-check-no-employee',
  PAY_TYPES = 'pay-types',
  PAY_PERIOD_GROUPS = 'pay-period-groups',
}

export enum HourCacheKeys {
  HOURS = 'time-card-hours',
  HOUR_AUDITS = 'time-card-hour-audits',
  DAILY_SUMMARY = 'time-card-daily-summary',
  PAY_PERIOD_SUMMARY = 'time-card-pay-period-summary',
  OTHER_HOURS = 'time-card-other-hours',
  OTHER_HOURS_FOR_PAY_DATE_CONFIGURATION = 'time-card-other-hours-for-pay-date-configuration',
  OTHER_HOURS_FOR_CONFIGURATION = 'time-card-other-hours-for-configuration',
  PBJ_HOURS = 'time-card-pbj-hours',
}

export enum TimeCardCacheKeys {
  TIME_CARD_PLACEHOLDERS = 'time-card-placeholders',
  PAY_PERIOD_COMMENT = 'time-card-pay-period-comments',
  PAY_PERIOD_APPROVAL = 'time-card-pay-period-approval',
  EMPLOYEE_TIME_CARD = 'employee-time-card',
  WEB_PUNCH_TODAY = 'time-card-web-punch-today',
}

export enum AccrualsKeys {
  ACCRUALS_BALANCE = 'time-card-accruals-balance',
  ACCRUALS_TAB_SETUP = 'time-card-accruals-tab-setup',
  ACCRUALS_ALL_TABS = 'time-card-accruals-all-tabs',

  ACCRUALS_BALANCE_TAB_DATA = 'time-card-accruals-balance-tab-data',
  ACCRUALS_DETAILS_TAB_DATA = 'time-card-accruals-details-tab-data',
  ACCRUALS_ANNUAL_ENTITLEMENTS_TAB_DATA = 'time-card-accruals-annual-entitlements-tab-data',
  ACCRUALS_ADJUSTMENTS_TAB_DATA = 'time-card-accruals-adjustments-tab-data',

  ACCRUAL_PAY_TYPES = 'time-card-accrual-pay-types',
  ACCRUAL_AUDIT = 'time-card-accrual-audit',
  ACCRUAL_AUDIT_FORM_SETUP = 'time-card-accrual-form-setup',
}

export enum ScheduleCacheKeys {
  EMPLOYEE_SCHEDULES = 'time-card-employee-schedules',
  EMPLOYEE_PLACEHOLDERS = 'time-card-employee-placeholders',
  EMPLOYEE_SCHEDULE_CONFIGURATION = 'time-card-employee-schedule-configuration',
  EMPLOYEE_SCHEDULE_AUDIT = 'time-card-employee-schedule-audit',
  EMPLOYEE_PLACEHOLDER_AUDIT = 'time-card-employee-placeholder-audit',
}

export enum PunchCacheKeys {
  EXCEPTIONS = 'time-card-exceptions',
  AUDIT = 'time-card-audit',
  PUNCH_CONFIGURATION = 'time-card-punch-configuration',
}

export enum ContactSupportCacheKeys {
  ContactSupportPermission = 'contact-support-permission',
}

export enum AttachmentsCacheKeys {
  ATTACHMENTS = 'employee-attachments',
}

export enum ToolsCacheKeys {
  ProcessingSetup = 'tools-processing-setup',
  ProcessingJobStatus = 'tools-processing-job-status',
  ClockGroups = 'tools-clock-groups',
  ClosePayPeriodSetup = 'tools-close-pay-period-setup',
  ImportSetup = 'tools-import-setup',
  ImportRun = 'tools-import-run',
  ImportRunRows = 'tools-import-run-rows',
  ImportHistory = 'tools-import-history',
}

export enum ConfigurationCacheKeys {
  OTHER_HOUR_DEFAULT_VALUES = 'time-card-other-hour-default-values',
}

export enum UserCacheKeys {
  EMPLOYEES_GROUPING_LABOR_LEVELS = 'time-card-employee-grouping-labor-level',
  EMPLOYEES_FILTER_SETTINGS = 'time-card-employee-filter-settings',
  USER_PREFERENCES = 'time-card-user-preferences',
  FULL_NAME_DISPLAY_ORDER = 'time-card-full-name-display-order',
  EMPLOYEE_INFO_TEXT = 'time-card-employee-info-text',
  EMPLOYEE_TIME_CARD_SETTINGS = 'time-card-employee-time-card-settings',
  RECENTLY_VIEWED_EMPLOYEES = 'time-card-recently-viewed-employees',
}
